import { render, staticRenderFns } from "./CmgCheckoutOrderDetails.vue?vue&type=template&id=b4460342&scoped=true&lang=pug&"
import script from "./cmg-checkout-order-details.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-order-details.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutOrderDetails.vue?vue&type=style&index=0&id=b4460342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4460342",
  null
  
)

export default component.exports